import { Route, Routes } from 'react-router-dom';
import Main from 'pages/Main';
import JoinInfo from 'pages/JoinInfo';
import MyPage from 'pages/MyPage';
import MemberShip from 'pages/MemberShip';
import Login from 'pages/Login';
import Join from 'pages/Join';
import Guide from 'pages/Guide';
import CustomerCenter from 'pages/CustomerCenter';
import DownLoad from 'pages/DownLoad';
import ServiceTerms from 'pages/ServiceTerms';
import IndividualTerms from 'pages/IndividualTerms';
import JoinComplete from 'pages/JoinComplete';
import Error from 'pages/Error';
import Update from 'pages/Update';

const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/membership" element={<MemberShip />} />
      <Route path="/joininfo" element={<JoinInfo />} />
      <Route path="/join" element={<Join />} />
      <Route path="/joincomplete" element={<JoinComplete />} />
      <Route path="/mypage" element={<MyPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/customercenter" element={<CustomerCenter />} />
      <Route path="/download" element={<DownLoad />} />
      <Route path="/terms/service" element={<ServiceTerms />} />
      <Route path="/terms/individual" element={<IndividualTerms />} />
      <Route path="/error" element={<Error />} />
      <Route path="/update" element={<Update />} />
    </Routes>
  );
};

export default MainRouter;
